/**
 * This array takes care of avoiding duplicated diamonds served by API
 *
 * @props
 * data: Object
 * selectedOptions: Array
 */
var DeduplicationMixin = {
  data: function () {
    return {
      stackedDiamonds: [],
    };
  },
  computed: {
    duplicateDuplicatedDiamonds: function () {
      return this.findDuplicates(this.stackedDiamonds);
    },
  },
  methods: {
    deduplicateDiamonds: function (diamonds) {
      return diamonds.filter(
        (d) => !this.duplicateDuplicatedDiamonds.includes(d.sku)
      );
    },
    deduplicateAddToStack: function (newStack) {
      this.stackedDiamonds = [
        ...this.stackedDiamonds,
        ...newStack.map((d) => d.sku),
      ];
    },
    duplicateClearStack: function () {
      this.stackedDiamonds = [];
    },
    findDuplicates: function (array) {
      const duplicates = [];
      const frequencyMap = {};

      for (let i = 0; i < array.length; i++) {
        const element = array[i];

        if (frequencyMap[element]) {
          if (!duplicates.includes(element)) {
            duplicates.push(element);
          }
        } else {
          frequencyMap[element] = true;
        }
      }
      return duplicates;
    },
  },
};
export default DeduplicationMixin;
